// Utility functions shared across react apps
import $ from "jquery";

const themeDir = "appreciationengine30";
const md5 = require('md5');
let BUCacheKey = null;

$(function(){
    BUCacheKey = $("body").data("bu-cache");//used to scope all local storage to current BU
});

export const urlParams = (url) => {
    return url.split("/");
}

//rounds to two decimal places
export const roundNumber = (number) => {
    number = Number(number);
	return Math.round(number * 100 + Number.EPSILON) / 100;
}

export const appendScript = (scriptToAppend) => {
    var script = document.createElement("script");
    script.src = "themes/" + themeDir + "/" + scriptToAppend;
    script.async = true;
    script.id = md5(scriptToAppend);

    if(!document.getElementById(script.id)) {//don't load the same js twice
   	    document.body.appendChild(script);
    }
    return true;
}

export const getPercentageChange = (now, then) => {
    now = Number(now);
    then = Number(then);
    if(then === 0) {
        if(now > 0) {
            return 100;
        }
        return 0;
    }
    return roundNumber(((now - then)/then)*100,0);
}

export const getPercentageDirection = (percentage) => {
    var direction = "";
    var change = percentage.toString();
    if(change.charAt(0) === "-"){
        change = change.slice(1);
        direction = "down";
    } else {
        direction = "up";
    }
    return direction;
}

//converts javascript Date() object to format DD/MM/YYYY
export const convertDate = (date) => {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;//for some mental reason core javascript starts months from 0 instead of 1
    var day = date.getDate();
    if(month.toString().length === 1) month = "0"+month;
    if(day.toString().length === 1) day = "0"+day;
    return day+"/"+month+"/"+year;
}

//converts date string in format YYYY-MM-DD H:i:s
export const strtotime = (string) => {
    return new Date(string.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")).getTime();
}

export const generateMetricHTML = (metric, append) => {
    if(!metric) return <div className="react-loading horizontal"></div>;
    var value = append ? metric+append : metric;
    return <span data-plugin="counterup" className="min-width-60">{value}</span>;
}

export const getNicePeriod = (period) => {
    var nicePeriod = period.toLowerCase();

    if(strstr(nicePeriod, "+")) nicePeriod = str_replace("+", " ", nicePeriod);
    if(strstr(nicePeriod, "day")) nicePeriod = str_replace("day", "Days", nicePeriod);
    if(strstr(nicePeriod, "week")) nicePeriod = str_replace("week", "Weeks", nicePeriod);

    return nicePeriod;
}

//TODO add second argument so we can just return Brands or Activities etc
export const getFromLocalStorage = (name, asString) => {
    if(!BUCacheKey) BUCacheKey = $("body").data("bu-cache");
    var data = window.localStorage.getItem(name+BUCacheKey);
    if(!data) return {};
    if(asString) return data;
    return JSON.parse(data);
}

export const sendToLocalStorage = (name, data) => {
    if(!data) data = {};
    if(!BUCacheKey) BUCacheKey = $("body").data("bu-cache");
    if(data.constructor.name === "Object") data = JSON.stringify(data);//convert to string to save in localStorage
    window.localStorage.setItem(name+BUCacheKey, data);
    return JSON.parse(data);
}

export const clearFromLocalStorage = (name) => {
    if(!BUCacheKey) BUCacheKey = $("body").data("bu-cache");
    window.localStorage.removeItem(name+BUCacheKey);
}

//capitalizes first word in a string
//courtesy of https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
export const ucfirst = (str) => {
    return String(str).charAt(0).toUpperCase() + String(str).slice(1);
}

//capitalizes all words in a string
//courtesy of https://stackoverflow.com/questions/5122402/uppercase-first-letter-of-variable
export const capitalize = (str) => {
    var strVal = '';
    if(str){
        str = str.split(' ');
        for (var chr = 0; chr < str.length; chr++) {
            strVal += str[chr].substring(0, 1).toUpperCase() + str[chr].substring(1, str[chr].length) + ' '
        }
    }
    return strVal
}

//javascript version of ApplicationsPage_Controller::capitalizationWithExceptions($label)
export const capitalizationWithExceptions = (str) => {
    switch (str.trim()) {  // Trim input before checking cases
        case 'lastfm':
            return 'Last.FM';
        case 'qq':
            return 'QQ';
        case 'soundcloud':
            return 'SoundCloud';
        case 'youtube':
            return 'YouTube';
        case 'wechat':
            return 'WeChat';
        case 'apple':
        case 'applemusic':
        case 'AppleMusic':
            return 'Apple Music';
        case 'amazon':
        case 'amazonmusic':
        case 'AmazonMusic':
            return 'Amazon Music';  
        case 'tiktok':
        case 'Tiktok':
            return 'TikTok';    
        case 'yahoojapan':
        case 'YahooJapan':
            return 'Yahoo Japan';
        default:
            return capitalize(str).trim();  // Ensure the default case trims as well
    }
}

// Source: https://stackoverflow.com/questions/7015181/javascript-or-jquery-equivalent-of-phps-strstr-function
export const strstr = (haystack, needle, bool) => {
    var pos = 0;

    haystack += "";
    pos = haystack.indexOf(needle); if (pos === -1) {
        return false;
    } else {
        if (bool) {
            return haystack.substr(0, pos);
        } else {
            return haystack.slice(pos);
        }
    }
}

export const str_replace = (search, replace, subject) => {
    subject = subject.toString();
    return subject.replaceAll(search, replace);
}

export const isset = (obj) => {
    if(!obj) return false;
    if(obj.constructor.name !== "Object") return false;
    return Object.keys(obj).length > 0;
}

//Source: https://stackoverflow.com/questions/1159277/javascript-equivalent-of-php-function-array-flip
// numberedIndex = true will return a numbered array of the keys instead of using the former values as the keys
export const array_flip = (array, numberedIndex=false) => {
    var key, index = 0, new_array = {};
    for (key in array){
        if (array.hasOwnProperty(key)){
            if(numberedIndex) new_array[index] = key;
            else new_array[array[key]] = key;
            index++;
        }
    }
    return new_array;
}

//mimics php's in_array
export const in_array = (needle, haystack) => {
    var check = $.inArray(needle, haystack);
    return check >= 0;
}

export const getGraphColours = () => {      
    let colours = [];   
    if ($("body").hasClass("FairShare")) { // FairShare colors
        colours = [
            "#43BDA5", "#FFCB76", "#FF966C", "#B91D52", "#E1DFEA", // Existing colors
            "#2E9382", "#FFA445", "#FF6D45", "#99153D", "#CBC7D7", // Additional darker variants
            "#63CBB4", "#FFE3A3", "#FFB693", "#D23869", "#F0EDF7"  // Additional lighter variants
        ];
    } else {
        colours = [
            "#7066D7", "#B5A9E5", "#FF9AB6", "#FF0080", "#CCCCCC", // Existing colors
            "#584AB6", "#9D8CCF", "#D87F9F", "#CC0066", "#A3A3A3", // Additional darker variants
            "#8A7FE5", "#D4CFEF", "#FFA4C7", "#FF3399", "#E0E0E0"  // Additional lighter variants
        ];
    }
    return colours;
}

export const getRandomInt = (max) => {
    if(!max) max = 100;
    return Math.floor(Math.random() * max);
}

export const getRefreshToken = () => {
    var date = new Date();
    return md5(date.getMilliseconds()+Math.random());
}

//removes null values from javascript objects
//credit: https://www.geeksforgeeks.org/remove-blank-attributes-from-a-javascript-object/
export const removeNestedNullUndefined = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
            acc[key] = typeof value === 'object' ? removeNestedNullUndefined(value) : value;
        }
        return acc;
    }, {});
}

export const isSimpleNavigation = (reportType) => {
    var searchStrings = ['login', 'registrations', 'all-members', 'visitor-metrics'];
    return searchStrings.some(substring => reportType.includes(substring));
}